import * as React from 'react'
// import { dateFormat } from '../../util'
// import * as moment from 'moment'
import './index.css'
import TimeLine from '../../components/TimeLine'
import BarChart from '../../components/BarChart'
import BarChartModel from '../../components/BarChartModel'

class AnalystDetails extends React.Component<any, any> {
    constructor(props: any) {
        super(props)
        this.state = {
            sortType: [
                {checked: true, name: '文章评分'},
                {checked: false, name: '按作者评分'},
                {checked: false, name: '按机构评分'},
                {checked: false, name: '按时间排序'}
            ],
            barChartData: [{name: 'Page A', uv: 4000, pv: 2400, amt: 2400},
                {name: 'Page B', uv: 3000, pv: 1398, amt: 2210},
                {name: 'Page C', uv: 2000, pv: 9800, amt: 2290},
                {name: 'Page D', uv: 2780, pv: 3908, amt: 2000},
                {name: 'Page E', uv: 1890, pv: 4800, amt: 2181},
                {name: 'Page F', uv: 2390, pv: 3800, amt: 2500},
                {name: 'Page G', uv: 3490, pv: 4300, amt: 2100},
            ],
            current: 1, //  当前页码
            pageSize: 5, //  每页显示的条数5条
            barChartVisible: false,
            score: {}, //  评分假数据
            topScore: [],
            topCompany: []
        }
    }
    componentDidMount() {
        this.setState(
            {
                score: this.getScore(),
                topScore: this.getTopScore(),
                topCompany: this.getTopCompany(),
            }
        )
    }
    handleCheckboxChange(index: any, checked: any, ind: number) {
        const {handleCheckboxChange} = this.props
        handleCheckboxChange(index, checked, ind)
    }
    showCheckbox(index: any) {
        const {showCheckbox} = this.props
        showCheckbox(index)
    }
    closeBarChart() {
        this.setState(
            {
                barChartVisible: false
            }
        )
    }

    changeBarChart() {
        this.setState(
            {
                barChartVisible: true
            }
        )
    }

    getScore() {
        const research: any = (Math.random() * 50 + 50).toFixed(0)
        const forecast: any = (Math.random() * 50 + 50).toFixed(0)
        let comprehensive: any = ((parseInt(research, 10) * 2 + parseInt(forecast, 10)) / 3).toFixed(0)
        return {
            research: research, forecast: forecast, comprehensive: comprehensive
        }
    }

    getTopScore() {
        let score = []
        let temp = []
        let industry = ['环保行业', '非金属类建材行业', '食品饮料行业', '医药行业', '机械行业', '轻工制造', '纺织和服装行业', '通信行业', '轨交行业', '公用事业行业', '电子行业', '钢铁行业', '电力行业', '交通运输行业', '汽车及零部件行业', '有色金属行业', '教育行业', '房地产行业', '证券信托行业', '银行行业', '家电行业', '零售业行业']
        for (let i = 0; i < 5; i++) {
            temp[i] = (Math.random() * 50 + 50).toFixed(0)
        }
        temp.sort(this.sortNumber)
        for (let i = 0; i < 5; i++) {
            score[i] = {}
            score[i] = {value: temp[i], name: industry[i]}
        }
        return score
    }

    sortNumber(a: any, b: any) {
        return b - a
    }

    getTopCompany() {
        let score = []
        let temp = []
        let industry = ['汇纳科技', '博世科', '鱼跃医疗', '通威股份', '中电环保', '百川能源', '跨境通', '立讯精密', '平安银行', '大业股份', '京新药业', '苏博特', '高新兴', '日海通讯', '富春环保', '华宏科技', '裕同科技', '四方冷链', '中泰化学', '蓝焰控股', '兴发集团', '山西证券', '华兰生物', '金科文化', '江中药业', '鱼跃医疗', '通化东宝', '京新药业', '中工国际', '新野纺织', '八一钢铁', '龙元建设', '雄韬股份']
        for (let i = 0; i < 5; i++) {
            temp[i] = (Math.random() * 50 + 50).toFixed(0)
        }
        temp.sort(this.sortNumber)
        for (let i = 0; i < 5; i++) {
            score[i] = {}
            score[i] = {value: temp[i], name: industry[i]}
        }
        return score
    }

    render() {
        const {newAuthor, author} = this.props
        const score = this.state.score
        const topScore = this.state.topScore
        const topCompany = this.state.topCompany
        const barChartData = this.state.barChartData
        return(

            <div className="author-header">
                {
                    newAuthor &&
                    <div className="header-content">
                        <div className="author-content">
                            <div className="author-card">
                                <div className="author-info">
                                    <div className="author-icon" style={{backgroundImage: 'url(' + newAuthor.photo_path + ')'}}/>
                                    <div className="author-profile">
                                        <h1>
                                            {newAuthor.analyst_name}
                                        </h1>
                                        <h3>
                                            {newAuthor.education}
                                        </h3>
                                        <p className="author-bio">
                                            {newAuthor.comp_name}
                                        </p>
                                        <p className="author-bio">
                                            职业证书编号:
                                        </p>
                                        <p className="author-bio">
                                            {newAuthor.sec_id}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="header-chart">
                                <div className="item">
                                    <div>{score.comprehensive}</div>
                                    <span>综合评分</span>
                                </div>
                                <div className="item">
                                    <div>{score.forecast}</div>
                                    <span>财务数据预测评分</span>
                                </div>
                                <div className="item">
                                    <div>{score.research}</div>
                                    <span>评级预测评分</span>
                                </div>
                                <div className="item" onClick={() => this.changeBarChart()}>
                                    <BarChart barData={barChartData}/>
                                    <BarChartModel visible={this.state.barChartVisible} closeBarChart={() => this.closeBarChart()} barData={barChartData}/>
                                    <span>各季度研报发布数量</span>
                                </div>
                            </div>
                        </div>
                        <div className="top-5">
                            <div className="scores">
                                <h1>{newAuthor.analyst_name}行业概念研究评分TOP5</h1>
                                {
                                    topScore && topScore.length > 0 && topScore.map((item: any, index: any) =>
                                        <div className="item" key={index}>
                                            <div className="score">{item.value}</div>
                                            <div className="title">{item.name}</div>
                                        </div>
                                    )
                                }
                            </div>
                            <div className="scores">
                                <h1>{newAuthor.analyst_name}公司研究评分TOP5</h1>
                                {
                                    topCompany && topCompany.length > 0 && topCompany.map((item: any, index: any) =>
                                        <div className="item" key={index}>
                                            <div className="score">{item.value}</div>
                                            <div className="title">{item.name}</div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                        <TimeLine Author={author}/>
                    </div>
                }
            </div>
        )
    }
}
export default AnalystDetails



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/AnalystDetails/index.tsx